export const getDashboardRedirectUrl = () => {
  const companyKey = sessionStorage.getItem("company-key");

  if (!companyKey || companyKey === "null" || companyKey === "undefined") {
    return null;
  }

  return `https://inspectionsupport.com/${encodeURIComponent(companyKey)}/dashboard`;
};

export const redirectToDashboard = (navigate) => {
  const dashboardUrl = getDashboardRedirectUrl();

  if (dashboardUrl) {
    window.location.assign(dashboardUrl);
    return;
  }

  navigate("/dashboard");
};
